module.exports = __webpack_public_path__ + "media/images/filter_button-3bc78014051db2481212deb6d8af48a7.svg";